import { Table, Tooltip, Popover as PopoverAntd, Card, Tag } from "antd";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
// import styled from "styled-components";
import {
  ColorCodeInterface,
  RiskColorCode,
} from "utilFunctions/Constants/Constants";
import moment from "moment";
import {
  calculatePercentage,
  roundToAnyDecimalPlaces,
} from "utilFunctions/helperFunctions/utilFunctions";
import { capitalizeFirstCharaterOfString } from "utilFunctions/helperFunctions/utilFunctions";
import { useContext, useEffect } from "react";
import "./index.css";
// import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch } from "Context/CommonContext";
import {
  BASE_URL,
  GET_TESTSYLLABUS_STATUS,
} from "utilFunctions/Constants/urlConstants";
import { usePutPostAPI } from "utilFunctions/CustomHooks/usePutPostAPI";
import { displayNumberWithDecimals } from "Pages/BranchHealth/BranchHealthTable";
import { useNavigate } from "react-router-dom";
import InfoIcon from "Assets/Icons/InfoIcon";
import {
  calculateCumulativePercentage,
  returnCumulativeTargetValuue,
  // returnPercentage,
} from "Pages/Faculties/FacultiesTable";
import Typography from "Components/CommonComponents/Typography";
import { DivStyledStatus, returnColor } from "Pages/MyLibrary/MyLibraryTable";

// const RiskStyledDiv = styled<any>("div")`
//   background-color: ${(props: any) => props.color};
//   border-radius: 4px;
//   border: 1px solid
//     ${(props: any) => (props.color == "#F5F5F5" ? "#757575" : props.color)};
//   padding: 4px;
//   width: fit-content;
//   cursor: pointer;
// `;
// const RiskStyledDSpan = styled<any>("span")`
//   color: ${(props: any) => props.color};
//   font-size: 14px;
//   font-style: normal;
//   font-weight: 600;
//   line-height: 20px; /* 142.857% */
// `;
export const returnPlannedLecture = (val1: number, val2: number) => {
  return val1 + "/" + val2;
};
export const returnRiskSegment = (
  percentage: number | string,
  additionalContent: any,
  isPlannedLecture: boolean
) => {
  const segment: any =
    percentage === "NA"
      ? "NA"
      : typeof percentage === "number" && percentage >= 100
      ? "Low"
      : typeof percentage === "number" && percentage < 100 && percentage > 75
      ? "Moderate"
      : "High";
  const colorCode = RiskColorCode.find(
    (item: ColorCodeInterface) => item.name === segment
  );
  return (
    <Tag color={isPlannedLecture ? "" : colorCode?.tagColor}>
      {additionalContent}
    </Tag>
  );
};
export const returnBatchData = (testSyllbStatus: any = [], id: number) => {
  return testSyllbStatus.filter((ele: any) => ele.batchId === id)?.[0]
    ?.testSyllabusStatusDataList;
};
export const popBodyShowComponentAntd: any = (popoverContent: any) => {
  return (
    <>
      <div className="d-flex gap-2">
        {popoverContent?.map((ele: any) =>
          returnRiskSegment(
            roundToAnyDecimalPlaces(
              Number(
                displayNumberWithDecimals(
                  calculatePercentage(ele.markedNodeCount, ele.totalNodeCount)
                )
              ),
              2
            ),
            ele?.subject &&
              capitalizeFirstCharaterOfString(ele?.subject) +
                " : " +
                roundToAnyDecimalPlaces(
                  Number(
                    displayNumberWithDecimals(
                      calculatePercentage(
                        ele.markedNodeCount,
                        ele.totalNodeCount
                      )
                    )
                  ),
                  2
                ) +
                " %",
            false
          )
        )}
      </div>
    </>
  );
};
export const popBodyShowComponentMonthlyTarget: any = (popoverContent: any) => {
  return (
    <>
      <div className="d-flex gap-2">
        {popoverContent?.map((ele: any) =>
          ele.monthlyTarget != null
            ? returnRiskSegment(
                roundToAnyDecimalPlaces(
                  Number(
                    displayNumberWithDecimals(
                      calculateCumulativePercentage(ele)
                    )
                  ),
                  2
                ),
                ele?.subj &&
                  capitalizeFirstCharaterOfString(ele?.subj) +
                    " : " +
                    roundToAnyDecimalPlaces(
                      Number(
                        displayNumberWithDecimals(
                          calculateCumulativePercentage(ele)
                        )
                      ),
                      2
                    ) +
                    " %",
                false
              )
            : returnRiskSegment(
                "NA",
                ele?.subj &&
                  capitalizeFirstCharaterOfString(ele?.subj) + " : " + "NA",
                false
              )
        )}
      </div>
    </>
  );
};
const SyllabusComplianceBatchAntdTable = ({
  tableloading,
  tableData,
  testSyllbStatus,
  setTestSyllabusStatus,
}: any) => {
  const navigate = useNavigate();
  const ToastDispatch = useContext(ToastContextDispatch);
  const { makeRequest: PostTestSyllabusStatus } = usePutPostAPI(
    (data: any) => {
      if (data["data"] && data["data"].length) {
        setTestSyllabusStatus(data["data"]);
      } else {
        setTestSyllabusStatus([]);
      }
    },
    (error) => {
      if (error && error["message"]) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    },
    "Post"
  );
  //   const togglePopover = (column: string, content: string) => {
  //     setHoveredColumn(column);
  //     setPopoverContent(content);
  //     setPopoverOpen(!popoverOpen);
  //   };

  //   const closePopover = () => {
  //     setHoveredColumn(null);
  //     setPopoverOpen(false);
  //   };
  const displayNumberWithDecimals = (number: any) => {
    if (Number.isInteger(number)) {
      return number.toString(); // Return the integer as a string
    } else {
      return number.toFixed(2); // Return the number with two decimals
    }
  };
  const renderingTime = (date: any) => {
    return <div className="d-flex">{moment(date).format("D MMM YY")}</div>;
  };

  const routeToMyBatch = (item: any) => {
    navigate("/admin/mybatch/" + item.id, {
      replace: false,
      state: {
        batch: item,
      },
    });
  };
  const routeToTest = (item: any) => {
    const testDetails = {
      type: item.testType,
      startDate: item.startDate,
      endDate: item.endDate,
    };
    navigate("/admin/mybatch/test/" + item.testId, {
      replace: false,
      state: {
        test: testDetails,
        batchId: item.id,
        testSyllabusStatus: testSyllbStatus,
        batchName: item.batchName,
      },
    });
  };

  const columns: any = [
    {
      title: "Batch Name",
      dataIndex: "batchName",
      width: 220,
      fixed: "left",
      render: (_: any, record: any) => {
        return (
          <span className="tableIdStyle" onClick={() => routeToMyBatch(record)}>
            {record.batchName}
          </span>
        );
      },
    },
    {
      title: "Planned Lecture Status",
      dataIndex: "plLecStatus",
      width: 250,
      render: (_: any, record: any) => {
        return (
          <PopoverAntd
            placement="leftTop"
            content={() =>
              record?.plLecStatus &&
              record?.plLecStatus != null &&
              record?.plLecStatus.map((ele: any, index: number) => (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center mb-2"
                >
                  <div key={ele.value + index}>
                    <DivStyledStatus color={returnColor(ele?.subj)}>
                      {ele?.subj}
                    </DivStyledStatus>
                  </div>
                  <div className="statusHeading">
                    {returnPlannedLecture(
                      ele.markedPlLecCount,
                      ele.totalPlLecCount
                    )}
                  </div>
                </div>
              ))
            }
            title="Planned lectures completed"
          >
            <div className="d-flex gap-2">
              {record?.plLecStatus &&
                record?.plLecStatus != null &&
                record?.plLecStatus?.map((ele: any) =>
                  returnRiskSegment(
                    roundToAnyDecimalPlaces(
                      Number(
                        displayNumberWithDecimals(
                          calculatePercentage(
                            ele.markedPlLecCount,
                            ele.totalPlLecCount
                          )
                        )
                      ),
                      2
                    ),
                    ele?.subj &&
                      capitalizeFirstCharaterOfString(ele?.subj) +
                        " : " +
                        returnPlannedLecture(
                          ele.markedPlLecCount,
                          ele.totalPlLecCount
                        ),
                    true
                  )
                )}
            </div>
          </PopoverAntd>
        );
      },
    },
    {
      title: () => (
        <Tooltip title="Test scheduled in the next 30 days.">
          <span>Upcoming Tests</span>
          <InfoIcon id={"Tooltip-attendance1"}></InfoIcon>
        </Tooltip>
      ),
      dataIndex: "testType",
      width: 220,
      render: (_: any, item: any) => {
        return (
          <div className="d-flex flex-row gap-2 align-items-center">
            {item?.testType && item.testType === "No Upcoming Test" ? (
              <span>{"Not Scheduled"}</span>
            ) : (
              <span className="filterSpan" onClick={() => routeToTest(item)}>
                {item?.testType}
              </span>
            )}{" "}
          </div>
        );
      },
    },
    {
      title: "Test Date",
      dataIndex: "testDate",
      width: 150,
      render: (_: any, item: any) => {
        return (
          <span> {item?.testDate ? renderingTime(item?.testDate) : "-"}</span>
        );
      },
    },
    {
      title: () => (
        <Tooltip title="Indicates the topics covered in the subject for the upcoming test of the particular batch.">
          <span>Test Syllabus Status</span>
          <InfoIcon id={"Tooltip-attendance1"}></InfoIcon>
        </Tooltip>
      ),
      dataIndex: "testSyllbStatus",
      width: 180,
      render: (_: any, item: any) => {
        return (
          <div>
            {returnBatchData(testSyllbStatus, item.batchId ?? item.id) ? (
              <PopoverAntd
                placement="leftTop"
                content={() => (
                  <div className="popup-class-scroll-style">
                    {returnBatchData(
                      testSyllbStatus,
                      item.batchId ?? item.id
                    ).map((ele: any, index: number) => (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center mb-2"
                      >
                        <div key={ele.value + index}>
                          <DivStyledStatus color={returnColor(ele?.subj)}>
                            {ele?.subj}
                          </DivStyledStatus>
                        </div>
                        <div className="statusHeading">
                          {returnPlannedLecture(
                            ele.markedNodeCount,
                            ele.totalNodeCount
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                title={" Total topics covered for the test"}
              >
                {returnBatchData(testSyllbStatus, item.batchId ?? item.id)
                  ? popBodyShowComponentAntd(
                      returnBatchData(testSyllbStatus, item.batchId ?? item.id)
                    )
                  : "-"}
              </PopoverAntd>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: () => (
        <Tooltip title="Percentage of planned lectures completed against the monthly target set by the central team">
          <span>Monthly Target %</span>
          <InfoIcon id={"Tooltip-attendance1"}></InfoIcon>
        </Tooltip>
      ),
      dataIndex: "plLecStatus",
      width: 250,
      render: (_: any, item: any) => {
        return item?.plLecStatus && item?.plLecStatus != null ? (
          <PopoverAntd
            placement="leftTop"
            content={() => (
              <div className="popup-class-scroll-style">
                {item?.plLecStatus &&
                item?.plLecStatus != null &&
                Array.isArray(item?.plLecStatus)
                  ? returnCumulativeTargetValuue(
                      "Marked planned lectures",
                      "Cumulative monthly target",
                      item?.plLecStatus
                    ).map((ele: any, index: number) =>
                      ele?.label == "Subject:" ? (
                        <div key={ele.value + index} className="mt-2">
                          <DivStyledStatus color={returnColor(ele.value)}>
                            {ele.value}
                          </DivStyledStatus>
                        </div>
                      ) : (
                        <div
                          key={index}
                          className={
                            "markedLectureCountStyle d-flex flex-column justify-content-between mb-2" +
                              ele.label ==
                            "Subject:"
                              ? "border-top"
                              : ""
                          }
                        >
                          <div className="d-flex flex-row w-100">
                            <Typography variant="h6" color="black">
                              {ele.label} &nbsp;
                            </Typography>
                            <Typography variant="h6" color="black">
                              {ele.value}
                            </Typography>
                          </div>
                        </div>
                      )
                    )
                  : null}
              </div>
            )}
            title={""}
          >
            {item?.plLecStatus &&
              item?.plLecStatus != null &&
              Array.isArray(item?.plLecStatus) && (
                <div
                  className={
                    item?.plLecStatus && item?.plLecStatus != null
                      ? "filterSpan"
                      : ""
                  }
                >
                  {item?.plLecStatus && item?.plLecStatus != null
                    ? popBodyShowComponentMonthlyTarget(item?.plLecStatus)
                    : "-"}
                </div>
              )}
          </PopoverAntd>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Total Students",
      dataIndex: "studentCount",
      width: 150,
      render: (_: any, item: any) => {
        return (
          <span> {item?.studentCount != null ? item?.studentCount : "-"}</span>
        );
      },
    },
  ];

  useEffect(() => {
    if (tableData && tableData.length > 0) {
      const url = BASE_URL + GET_TESTSYLLABUS_STATUS;
      const obj = (tableData || []).map((ele: any) => ({
        batchId: ele.id,
        testScheduleId: ele.testId,
      }));
      const filteredList = obj.filter((ele: any) => ele.testScheduleId != null);
      if (filteredList.length > 0) {
        PostTestSyllabusStatus(url, filteredList);
      }
    }
  }, [tableData]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    document.body.classList.add("noOverflow");
    return () => {
      document.body.classList.remove("noOverflow");
    };
  }, []);
  return (
    <div>
      <div className="tableFixHead">
        {!tableloading && tableData && tableData.length === 0 ? (
          <Card>
            <div className="mt-4 mb-8">
              <NoResultFoundSearch
                primaryMessage="Batch list not available."
                secondaryMessage={
                  "No batches allotted to the selected Branch and Stream. Try changing the filter or contact your EDP team for assistance."
                }
              >
                <NoDataFoundIcon />
              </NoResultFoundSearch>
            </div>
          </Card>
        ) : (
          <Table
            scroll={{ x: "max-content", y: "70vh" }}
            bordered
            size="small"
            columns={columns}
            dataSource={tableData}
            pagination={false}
            loading={tableloading}
          />
        )}
      </div>
    </div>
  );
};

export default SyllabusComplianceBatchAntdTable;
